import React from 'react';
import { SideBarMenuItem } from '../../../types/sidebar.types';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

const MenuItemComponent: React.FC<SideBarMenuItem> = ({
    label,
    icon,
    url,
    active,
    exact = false,
}) => {
    const { pathname } = useLocation();

    if (active === false) return <></>;

    const normalizedUrl = url !== '/' ? url.replace(/\/$/, '') : url;
    const isActive =
        normalizedUrl === '/' || exact
            ? pathname === normalizedUrl
            : pathname === normalizedUrl ||
              pathname.startsWith(`${normalizedUrl}/`);

    return (
        <ListItemButton
            {...{ to: url }}
            LinkComponent={Link}
            className={isActive ? 'active' : ''}>
            {icon && (
                <ListItemIcon
                    sx={{
                        margin: 0,
                    }}>
                    {icon}
                </ListItemIcon>
            )}
            <ListItemText primary={label} />
        </ListItemButton>
    );
};

export default MenuItemComponent;
